import React from 'react';
import { useLocale } from 'locale';
import Footer from 'components/static-footer';
import { useImageUrlBuilder } from 'hooks/useImageUrlBuilder';
import { ShowAt, useScreenBreakpoint } from 'consts/breakpoints';
import { SpacingBlock } from 'components/spacing-block';
import Search from './search';
import * as Styled from './styled';
import DevelopersSearchList from './DevelopersSearchList';
import { DevelopersBreadcrumbs } from 'screens/DeveloperPage/DeveloperPage';


const FOLDER = 'developer-page/';
const desktopImagePath = `${FOLDER}cover-desktop.png`;
const tabletImagePage = `${FOLDER}cover-tablet.png`;
const mobileImagePath = `${FOLDER}cover-mobile.png`;
const RATIO = 2;

interface DevelopersSearchPageOwnProps {
  headerScrollToRef?: React.Ref<HTMLHeadingElement>;
}

const DevelopersSearchPage: React.FC<DevelopersSearchPageOwnProps> = (props) => {
  const constructImageURI = useImageUrlBuilder();
  const screen = useScreenBreakpoint();
  const { t } = useLocale();
  const desktopImageSrc = constructImageURI(desktopImagePath, { width: Styled.screenToImageWidth[screen] * RATIO });
  const tabletImageSrc = constructImageURI(tabletImagePage, { width: Styled.screenToImageWidth[screen] * RATIO });
  const mobileImageSrc = constructImageURI(mobileImagePath, { height: 447 * RATIO });

  return (
    <>
      <Styled.CoverWrapper>
        <Styled.CoverInner>
          <Styled.Title weight="extraBold">{t('developersSearchPage.title')}</Styled.Title>
          <Styled.Description>{t('developersSearchPage.description')}</Styled.Description>
          <Styled.SearchWrapper>
            <Search />
          </Styled.SearchWrapper>
        </Styled.CoverInner>
        <Styled.CoverImage src={mobileImageSrc}>
          <ShowAt from={3}>
            <img src={desktopImageSrc} width={Styled.screenToImageWidth[screen]} />
          </ShowAt>
          <ShowAt at={2}>
            <img src={tabletImageSrc} width={Styled.screenToImageWidth[screen]} />
          </ShowAt>
          <ShowAt at={1}>
            <Styled.CoverImageOverlay />
          </ShowAt>
        </Styled.CoverImage>
      </Styled.CoverWrapper>
      <DevelopersSearchList />
      <SpacingBlock mTop={5}>
        <Footer breadcrumbs={<DevelopersBreadcrumbs />} noBorderTop />
      </SpacingBlock>
    </>
  );
};

export default DevelopersSearchPage;
